<template>
  <form>
    <section class="box-wrap" v-if="mainLogs">
      <div
        class="box"
        v-for="(main, index) of mainLogs"
        :key="`box-${index}`"
      >
        <TheInput
          :dark="true"
          label="РАЗХОД (СТОЙНОСТ)"
          placeholder="Въведете стойност"
          :digitsOnly="true"
          :disabled="main._id"
          v-model="main.price"
        />
        <TheInput
          :dark="true"
          type="dropdown"
          :options="maintenanceTypes"
          label="ВИД РАЗХОД"
          placeholder="Изберете"
          :disabled="main._id"
          v-model="main.activity"
          @update:modelValue="setExpense(index, $event)"
        />
        <TheInput
          :dark="true"
          label="ЗАБЕЛЕЖКА"
          placeholder="Попълнете"
          :disabled="main._id"
          v-model="main.note"
        />
      </div>
    </section>

    <div @click="addMaintenance()" class="add">
      <span class="mck">L</span>
      <p>
        {{ `Добавете ${!mainLogs || !mainLogs.length ? "" : "друг"} разход` }}
      </p>
    </div>
  </form>
</template>

<script>
import TheInput from "@/components/TheInput.vue";
export default {
  props: ["inventory", "type", "logs"],
  components: { TheInput },
  computed:{
    mainLogs(){
      return this.logs.filter((l) => !l.isEvent)
    }
  },
  data() {
    return {
      maintenanceTypes: [
        "Ремонти",
        "Данъци",
        "Винетки",
        "Каско",
        "ГТП",
        "ГО",
        "Лизинг",
        "Гориво",
        "Други",
      ],
    };
  },
  methods: {
    setExpense(index, e) {
      this.$set(this.mainLogs[index], "activity", e);
    },
    addMaintenance() {
      if (!this.logs) this.$set(this.inventory, "logs", []);

      this.logs.push({});
    },
  },
};
</script>
